import { useAuth } from '@/lib/auth';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/lib/i18n';

const PLAN_LIMITS = {
  free: {
    daily_meals: 3,
    modules: ['nutrition', 'cycle', 'menopause'],
    heatmap: false,
    ai_coach: false,
    selfie_glow: false,
    pdf_reports: false,
    full_hashimoto: false,
    video_library: false,
  },
  basis: {
    daily_meals: Infinity,
    modules: ['nutrition', 'hashimoto', 'cycle', 'menopause', 'glow'],
    heatmap: true,
    ai_coach: true,
    selfie_glow: true,
    pdf_reports: true,
    full_hashimoto: true,
    video_library: true,
  },
  premium: {
    daily_meals: Infinity,
    modules: ['nutrition', 'hashimoto', 'cycle', 'menopause', 'glow'],
    heatmap: true,
    ai_coach: true,
    selfie_glow: true,
    pdf_reports: true,
    full_hashimoto: true,
    video_library: true,
    personal_chat: true,
    live_calls: true,
  },
};

export function usePlan() {
  const { user } = useAuth();
  const plan = user?.plan || 'free';
  const limits = PLAN_LIMITS[plan] || PLAN_LIMITS.free;

  const canAccess = (feature) => !!limits[feature];
  const hasModule = (mod) => limits.modules?.includes(mod);
  const isPremium = plan === 'premium';
  const isBasis = plan === 'basis' || plan === 'premium';
  const isFree = plan === 'free';

  return { plan, limits, canAccess, hasModule, isPremium, isBasis, isFree };
}
